import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const FOUNDER_IMG =
  "https://images.pexels.com/photos/102984/pexels-photo-102984.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const STORY = [
  {
    h: "It started with a controller and a cold cup of coffee.",
    p: "Late nights of sim-racing, weekends of building, and a 3D printer that's been working overtime. Apex Designs was founded by Riaan Vatsa, a 7th grader — born in his bedroom, somewhere between a math test and a flying lap on a virtual circuit.",
  },
  {
    h: "Built in the gaps between homework.",
    p: "Every frame is hand-spec'd in our home studio in Mumbai. Inspiration arrives from anywhere: Forza replays, garage tours on YouTube, a freshly extruded part popping off the print bed.",
  },
  {
    h: "Brick. Print. Ship.",
    p: "We design and prototype every model. We pick parts that hold up. We engineer custom display stands. And we ship across India in 48 hours — packed in pit-lane red boxes.",
  },
];

const PILLARS = [
  {
    label: "Gaming",
    text: "Years of sim-racing taught us what makes a car feel alive. We obsess over silhouettes, downforce stance and livery moods.",
  },
  {
    label: "Building",
    text: "From the very first construction set to today's hyper-detailed brick frames — building is meditation, and engineering is the goal.",
  },
  {
    label: "3D Printing",
    text: "A workshop full of extruders, FDM and resin parts. We prototype custom mounts, badges and the steering wheels you see in our coming-soon drops.",
  },
  {
    label: "Motorsport",
    text: "F1, IndyCar, endurance racing — if it goes fast and looks ferocious, we want to build it.",
  },
];

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <Header />

      <section className="border-b border-white/10 bg-black/40">
        <div className="max-w-7xl mx-auto px-6 md:px-12 pt-20 pb-12 md:pt-28 grid md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-8">
            <p className="af-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-4">
              // Pit lane / Origin story
            </p>
            <h1
              className="af-display text-5xl md:text-7xl font-black uppercase tracking-tighter leading-[0.92]"
              data-testid="about-title"
            >
              Riaan Vatsa,
              <br />
              <span className="af-outline-text">a 3D printer,</span>
              <br />
              and a love for speed.
            </h1>
          </div>
          <div className="md:col-span-4">
            <div className="af-card p-6">
              <p className="af-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">
                // Headquarters
              </p>
              <p className="af-display text-2xl font-bold mt-2">Mumbai, IN</p>
              <p className="af-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500 mt-6">
                // Founded
              </p>
              <p className="af-display text-2xl font-bold mt-2">2026</p>
              <p className="af-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500 mt-6">
                // Founder
              </p>
              <p className="af-display text-2xl font-bold mt-2">Riaan Vatsa</p>
              <p className="af-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 mt-1">
                Class VII
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-7 space-y-10">
          {STORY.map((s, i) => (
            <div key={i} className="border-l border-white/15 pl-6">
              <p className="af-mono text-[10px] uppercase tracking-[0.25em] text-[#FF2800]">
                // 0{i + 1}
              </p>
              <h3 className="af-display text-2xl md:text-3xl font-bold tracking-tight mt-3">
                {s.h}
              </h3>
              <p className="text-zinc-400 mt-3 leading-relaxed">{s.p}</p>
            </div>
          ))}
        </div>
        <div className="md:col-span-5">
          <div className="af-card overflow-hidden sticky top-24">
            <img
              src={FOUNDER_IMG}
              alt="Hand-built model car"
              className="w-full h-[420px] object-cover"
            />
            <div className="p-6">
              <p className="af-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">
                // From the studio
              </p>
              <p className="text-zinc-300 mt-2 text-sm leading-relaxed">
                "I want every shelf in India to have a frame that feels like
                race-day morning."
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#080808] border-y border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
          <p className="af-mono text-[10px] uppercase tracking-[0.3em] text-[#00E5FF] mb-4">
            // The four pillars
          </p>
          <h2 className="af-display text-4xl md:text-5xl font-bold uppercase tracking-tight max-w-3xl">
            Inspired by the things we'd never put down.
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mt-12">
            {PILLARS.map((p) => (
              <div
                key={p.label}
                className="af-card p-6"
                data-testid={`pillar-${p.label.toLowerCase()}`}
              >
                <p className="af-mono text-[10px] uppercase tracking-[0.25em] text-[#FF2800]">
                  {p.label}
                </p>
                <p className="text-zinc-300 mt-4 text-sm leading-relaxed">
                  {p.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
